/* ============================================================================
   Hoodie Launch — Cross-fade slideshow + dot navigation
   ----------------------------------------------------------------------------
   - Auto-advances every `data-rotate-ms` (set to 0 to disable)
   - Pauses while user hovers the media area or tab is hidden
   - Pauses entirely when prefers-reduced-motion is set
   - Dot clicks navigate manually (and reset the auto-rotate timer)
   ========================================================================== */

(function () {
  if (window.customElements.get('hoodie-launch')) return;

  const PREFERS_REDUCED_MOTION = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  class HoodieLaunch extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('[data-launch-media]');
      this.slides = Array.from(this.querySelectorAll('[data-launch-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-launch-dot]'));
      this.currentIndex = 0;
      this.intervalMs = parseInt(this.dataset.rotateMs || '4000', 10);
      this.timer = null;
      this.isHovering = false;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => this.goTo(idx, true));
      });

      if (this.media) {
        this.media.addEventListener('mouseenter', () => {
          this.isHovering = true;
          this._stop();
        });
        this.media.addEventListener('mouseleave', () => {
          this.isHovering = false;
          this._start();
        });
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._stop();
        else if (!this.isHovering) this._start();
      });

      this._start();
    }

    disconnectedCallback() {
      this._stop();
    }

    _start() {
      if (PREFERS_REDUCED_MOTION) return;
      if (this.intervalMs <= 0) return;
      this._stop();
      this.timer = window.setInterval(() => {
        this.goTo((this.currentIndex + 1) % this.slides.length, false);
      }, this.intervalMs);
    }

    _stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    goTo(idx, manual) {
      if (idx === this.currentIndex) return;
      const prev = this.slides[this.currentIndex];
      const next = this.slides[idx];
      if (!next) return;

      if (prev) prev.classList.remove('is-active');
      next.classList.add('is-active');

      this.dots.forEach((dot, i) => {
        const active = i === idx;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.currentIndex = idx;
      if (manual) this._start();
    }
  }

  window.customElements.define('hoodie-launch', HoodieLaunch);
})();
